module.exports = __webpack_public_path__ + "static/media/kate-mara-lose.39703fbf.jpg";